module.exports = __webpack_public_path__ + "img/xeno-1.c847fb9c.jpg";